// because for some reason, new Date(.) is 0-indexed...
export function createProperDate(year: number, month: number, day: number): Date {
  return new Date(year, month - 1, day);
}

export const getCurrentTimestamp = (): string => new Date().toISOString();

export const getCurrentUTCTimestamp = (): number => Math.round(new Date().getTime() / 1000);
